package ui.component

import emotion.react.css
import helpers.isPhone
import js.lazy.Lazy
import js.reflect.upcast
import react.*
import react.dom.html.ReactHTML
import ru.malygin.dataConverter.MainScheduleComponents
import ru.malygin.dataConverter.MainScheduleItems
import ru.malygin.myConst.SelectedCategory
import ru.malygin.myConst.jsMainIsDebug
import ui.component.buttons.iconButton
import ui.component.external.*
import ui.new_ui.components.card_item.CardItem
import ui.styles.Colors
import ui.styles.MainElementCardContentStyle
import ui.styles.Styles
import ui.styles.icons.ArrowDownRoundedIconSVG
import ui.styles.icons.ExpandContentIconSVG
import ui.styles.icons.IconsSVG
import utils.logger.log
import web.cssom.*
import web.dom.document
import web.html.HTMLDivElement
import web.timers.clearTimeout
import web.timers.setTimeout
import kotlin.random.Random

class MainScreenComponentsOpen(
    category: SelectedCategory?,
    val selectedGroupForTutor: String? = null,
) {

    /**
     * CardContent - PER ITEM __FOR ONE__
     *
     * (...если во время конкретной пары только одна группа)
     *
     * @see SelectedCategory.GROUPS
     * @see SelectedCategory.TUTORS
     */
    val cardContent = FC<CardPerItemProps> {cardPerItemProps ->
        val msComponents = MainScheduleComponents(
            item = cardPerItemProps.itemDto,
            timeDetectorItem = cardPerItemProps.timeDetectorItem
        )

        var isExpand by useState(false)

        val tName = when(category){
            SelectedCategory.TEACHERS -> {msComponents.getGroupName()}
            else -> msComponents.getTeacherName()
        }

        ReactHTML.div{

            css{
                textAlign = TextAlign.start
                width = 100.pct
            }

            CardComponent.timeC{
                this.msComponents = msComponents
            }

            if(msComponents.getRoomNumber().isNullOrEmpty() && msComponents.getLessonName().isNullOrEmpty()){
                ReactHTML.span{
                    css{
                        paddingTop = 8.px
                    }

                    +msComponents.noDataText
                }
            }

            msComponents.getRoomNumber()?.let { rN->
                ReactHTML.span{
                    css {
                        paddingTop = 8.px
                        display = Display.flex
                    }

                    +"Аудитория: "
                    ReactHTML.h4{
                        css {
                            paddingInline = 2.px
                            backgroundColor = Colors.brCard
                            color = Colors.secondaryMain
                            fontWeight = FontWeight.bold
                        }

                        +rN
                    }
                }
            }
            msComponents.getLessonName()?.let { lN->
                expandText{
                    this.uniqId = cardPerItemProps.itemDto.id.toString()
                    this.expandText = lN
                    this.isExpanded = isExpand
                    this.onClick = {
                        isExpand = it
                    }
                }
            }
            tName?.let { tN->
                ReactHTML.h3{
                    css {
                        fontWeight = FontWeight.bold
                        paddingTop = 5.px
                    }

                    +tN
                }
            }
        }

        CardComponent.actualIdC{
            this.msComponents = msComponents
        }
    }

    val cardContentMulti = FC<CardPerItemMultiProps> {props ->
        dialogMIG{
            this.itemDto = props.itemDto
            this.category = category!!
            this.timeDetectorItem = props.timeDetectorItem
        }


        val msComponents = MainScheduleComponents(
            item = props.itemDto.first(),
            timeDetectorItem = props.timeDetectorItem
        )

        val groupList = props.itemDto.map { it.groupName }

        ReactHTML.div{

            css{
                textAlign = TextAlign.start
            }

            CardComponent.timeC{
                this.msComponents = msComponents
            }

            /**
             * отображает список групп
             */
            groupList.forEach {gN->

                ReactHTML.h3{
                    css {
                        fontWeight = FontWeight.bold
                    }

                    +gN
                }
            }
        }

        /**
         * отображает кнопку для показа информации по группам
         */
        ReactHTML.div{
            className = MainElementCardContentStyle.cardMoreButtonForTeachers

//            NewDialog{//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//                this.dialogData = NewDialogData(
//                    dialogInfo = NewDialogEnum.MAIN_LIST_SUB_INFO_FOR_TEACHER_DIALOG,
//                    data__ = props.itemDto,
//                    plusID = props.itemDto.first().actualId
//                )
//            }

            iconButton{
                onClick = {
                    dialogMigShow(
                        whatDialog = Dialogs.DIALOG_MIG,
                        itemDto = props.itemDto
                    )
//                    toggleDialog(NewDialogEnum.MAIN_LIST_SUB_INFO_FOR_TEACHER_DIALOG,
//                        plusID = props.itemDto.first().actualId)
                }

                realIconSVG = ExpandContentIconSVG

                plusMessageLeft = if (!isPhone()) this.realIconSVG?.description else null
            }
        }

        CardComponent.actualIdC{
            this.msComponents = msComponents
        }
    }

    //todo ...IN PROGRESS
    val expandText = FC<ExpandTextProps>{expandTextProps ->
        
        ReactHTML.div{

            css {
                display = Display.flex
                paddingTop = 5.px
            }

            ReactHTML.div{
                className = ClassName(Styles.Expanded.expandedText.toString() +if (expandTextProps.isExpanded)" ${Styles.Expanded.expandedTextExp}" else "")

                onClick = {expandTextProps.onClick(!expandTextProps.isExpanded)}

//                ReactHTML.button{
//                    className = Styles.Expanded.expandedTextBtn
//
//                    css(this.className) {
//                        border = None.none
//                        borderRadius = 4.px
//                    }
//
//
//                    ArrowDownRoundedIconSVG.iconSVG{
//                        this.pl = mapOf(
//                            "id" to expandTextProps.uniqId,
//                            "rotate" to if (expandTextProps.isExpanded) "180" else "0"
//                        )
//                    }
//                }

                +expandTextProps.expandText
            }
        }


    }

    /**
     * TabPanel
     *
     * Панель отображающая данные на конкретный день
     */
    val tabPanelCard = FC<TabPanelProps> { tabPanelProps ->

        /**
         * Список разбитый по парам
         */
        val newItemsCollector = MainScheduleItems(
            dataList = tabPanelProps.itemsDto,
            category = category!!
        ).returnSupportForList()

//        log.d("items from tabPanel: ${tabPanelProps.itemsDto}")

        when(category){
            SelectedCategory.TUTORS -> {
                /**
                 * Разделение по группам для
                 *
                 * @see SelectedCategory.TUTORS
                 */
                val tutorCollector = newItemsCollector?.groupBy { it.dataForOne!!.groupName!! } ?: run { null }

                val loc = tutorCollector?.getOrElse(
                    key = selectedGroupForTutor.toString()
                ){
                    tutorCollector.values.first()
                }?: run { null }
                loc
            }
            else -> {
                newItemsCollector
            }
        }?.forEachIndexed { _, itemDto ->

            CardItem{
                css = {}
                when (itemDto.counter) {
                    null -> {}
                    1 -> {
                        cardContent{
                            this.itemDto = itemDto.dataForOne!!
                            this.timeDetectorItem = tabPanelProps.timeDetectorItem
                        }
                    }
                    else -> {
                        cardContentMulti{
                            this.itemDto = itemDto.dataForMore!!
                            this.timeDetectorItem = tabPanelProps.timeDetectorItem
                        }
                    }
                }
            }

        }?: run{//если нет данных, todo доделать (красоту)
            ReactHTML.div{
                className = Styles.Elements.card
                +"Нет данных"
            }
        }
    }

    /**
     * Skeleton - ON LOAD
     */
    val onLoadingSkeleton = FC<Props>{

        (1..9).forEach { _ ->

            ReactHTML.span{
                className = Styles.Skeletoner.skeletoner
                css(this.className) {
                    height = 50.px
                    marginBottom = 10.px
                }
            }
        }
    }
}

private external interface PropsCard: Props{
    var msComponents: MainScheduleComponents
}

private object CardComponent{

    /**
     * отображает время пар
     */
    val timeC = FC<PropsCard>{props->
        ReactHTML.div{
            className = MainElementCardContentStyle.timeInCard
            val time = props.msComponents.getTimeAll()

            ReactHTML.h3{
                className = MainElementCardContentStyle.timeInCardFirstComponent

                +time.first()
            }

            if (time.size > 1) {
                ReactHTML.h4{
                    className = MainElementCardContentStyle.timeInCardSecondComponent

                    +"-${time.last()}".plus(
                        if (jsMainIsDebug)
                            " [db_${props.msComponents.debug_getDateTime()}]"
                        else ""
                    )
                }
            }
        }
    }

    /**
     * отображает номер пары
     */
    val actualIdC = FC<PropsCard>{props->

        ReactHTML.div{
            className = MainElementCardContentStyle.actualId

            props.msComponents.getActualId().also { aI->
                ReactHTML.h1{

                    +aI
                }
            }
        }
    }

}